import get from 'lodash.get';

export const selectSearchData = (state) => get(state, 'searchData', '');
export const selectSearchPerformed = (state) => get(state, 'searchPerformed');
